/*eslint-disable*/ export const messages = JSON.parse("{\"breadcrumbs.ariaLabel\":[\"Du är här\"]}");
//# sourceMappingURL=messages.mjs.map